import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { queryClient } from './query-client';
import { AuthProvider } from './auth/auth-provider';
import { ThemeProvider } from './theme/theme-provider';
import { Toaster } from '@/lib/ui/toast';

/** App-wide providers: theme, i18n, server-state cache, auth session, and the toaster. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            {children}
            <Toaster />
          </AuthProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </ThemeProvider>
  );
}
